module.exports = __webpack_public_path__ + "images/canonical-comment/complete-icon.6796a3605cea682b2200.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-comment/complete-icon.svg
// module id = 63KW
// module chunks = 2